import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BreadcrumbService, BreadcrumbItem } from '../../services/breadcrumb.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  @Input() containerStyle: 'wide' | 'normal' = 'normal';
  
  breadcrumbs: BreadcrumbItem[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.breadcrumbService.breadcrumbs$
      .pipe(takeUntil(this.destroy$))
      .subscribe(breadcrumbs => {
        this.breadcrumbs = breadcrumbs;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack() {
    this.location.back();
  }

  navigateTo(item: BreadcrumbItem) {
    if (item.url) {
      // Limpar breadcrumbs antes de navegar para evitar níveis antigos
      this.breadcrumbService.clear();
      
      // Se o item tem queryParams específicos, usar eles
      // Caso contrário, preservar os queryParams atuais apenas se a URL for a mesma
      let queryParams = item.queryParams;
      
      if (!queryParams && item.url === this.router.url.split('?')[0]) {
        // Se navegando para a mesma rota, preservar queryParams atuais
        queryParams = this.route.snapshot.queryParams;
      }
      
      this.router.navigate([item.url], { 
        queryParams: queryParams || {},
        preserveFragment: true
      });
    }
  }

  getContainerClass(): string {
    return this.containerStyle === 'wide' ? 'container-wide' : 'container-normal';
  }
} 